import Vue from 'vue';
import Buefy from 'buefy';
//import Raven from 'raven-js';
//import RavenVue from 'raven-js/plugins/vue';
import Analytics from 'vue-ua';
import ScrollTo from 'vue-scrollto';
import App from './App';
import router from './router';
import api from './api';
import store from './store';

//Raven
//    .config('https://c59aa490039445cebf077aeb0821f84f@sentry.io/294006')
//    .addPlugin(RavenVue, Vue)
//    .install();

Vue.use(Analytics, {
  appName: 'pre-survey',
  appVersion: '0.1.0',
  trackingId: 'UA-115134037-1',
  debug: false,
  vueRouter: router,
});

Vue.config.productionTip = false;

Vue.use(Buefy);
Vue.use(ScrollTo);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  api,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js